import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/approveworkhours",
      name: "approveworkhours",
      meta: { requiresAuth: true, title: "routes.approveWorkHours" },
      component: () => import("./main.vue")
    }
  ]
};
